import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-cream text-ink" data-id="element-200" data-mp="3041vsg1w7mbm">
      <a href="#contenu" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-aloe-900 focus:px-4 focus:py-2 focus:text-cream" data-id="element-201" data-mp="3064udoh42nry">
        Aller au contenu
      </a>
      <Header data-id="element-202" data-mp="3f2m4kcdkdwcx" />
      <main id="contenu" className="flex-1" data-id="element-203" data-mp="3f2vsluf1ttfz">
        <Outlet data-id="element-204" data-mp="3j35yl72ucjuu" />
      </main>
      <Footer data-id="element-205" data-mp="3j3fsv6ux5d6c" />
    </div>;
}